var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('div',{staticClass:"content"},[(_vm.loaded)?[(_vm.data.assinaturaEletronicaAtiva)?_c('AssinaturaEletronicaInstacacao',{ref:"AssinaturaEletronicaInstacacao"}):_vm._e()]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }